export default __webpack_public_path__ + "static/media/Heart.be2b442e.svg";